import {
    AfterViewInit,
    Directive,
    ElementRef,
    HostListener,
    inject,
    OnDestroy,
    Output,
    EventEmitter,
} from '@angular/core';

@Directive({
    selector: '[wfeDetectEllipsis]',
})
export class DetectEllipsisDirective implements AfterViewInit, OnDestroy {
    @Output() ellipsedChange = new EventEmitter<boolean>();

    private resizeObserver!: ResizeObserver;
    private initialTimeoutId?: number;
    private debounceId?: number;
    private lastEmitted?: boolean;
    private readonly el = inject(ElementRef<HTMLElement>);

    ngAfterViewInit(): void {
        this.initResizeObserver();
        this.initialTimeoutId = window.setTimeout(
            () => this.updateEllipsis(),
            200,
        );
    }

    ngOnDestroy(): void {
        if (this.initialTimeoutId) clearTimeout(this.initialTimeoutId);
        if (this.debounceId) clearTimeout(this.debounceId);
        this.resizeObserver?.disconnect();
    }

    @HostListener('window:resize')
    onResize(): void {
        this.scheduleUpdate(120);
    }

    private scheduleUpdate(delayMs: number): void {
        if (this.debounceId) clearTimeout(this.debounceId);
        this.debounceId = window.setTimeout(
            () => this.updateEllipsis(),
            delayMs,
        );
    }

    private updateEllipsis(): void {
        const el = this.el.nativeElement;
        requestAnimationFrame(() => {
            const visible = !!(el.offsetParent || el.getClientRects().length);
            if (!visible) {
                this.tryEmit(false);
                return;
            }
            const ow = el.offsetWidth;
            const sw = el.scrollWidth;

            if (ow === 0) {
                requestAnimationFrame(() => this.updateEllipsis());
                return;
            }

            const next = sw > ow;
            this.tryEmit(next);
        });
    }

    private tryEmit(next: boolean): void {
        if (this.lastEmitted === next) return;
        this.lastEmitted = next;
        this.ellipsedChange.emit(next);
    }

    private initResizeObserver(): void {
        this.resizeObserver = new ResizeObserver(() => {
            this.scheduleUpdate(100);
        });
        this.resizeObserver.observe(this.el.nativeElement);
    }
}
